export default [
    [1, 2, 5, 6],
    [4, 5.5, 8, 10.5],
    [7, 9, 11, 15],
    [8, 9.5, 12, 14],
    [7.5, 9, 11, 12],
    [4, 7, 10.5, 11],
    [2.5, 5, 9, 10.5],
    [2, 4.5, 8, 9.5],
    [1.5, 3.5, 7, 8.2],
    [1.8, 3.25, 6, 7.5],
    [2.4, 4, 7, 7.75],
    [2.8, 5, 7.5, 9],
    [4, 5.5, 8, 10],
    [3.8, 5.75, 8.75, 11],
    [4, 5.5, 8.5, 10],
    [4.5, 6, 7.5, 9],
    [5.9, 6.3, 7.2, 7.6],
    [5.96541324521645564456, 6.3, 7.2, 8],
];


// WEBPACK FOOTER //
// ./src/graph-components/data.js